<template>
  <div>
    <h5 class="etapa-titulo">Como este grupo se chama?</h5>

    <CRow>
      <CCol col="12" md="6">
        <CInput
          label="Nome do grupo *"
          v-model="form.nome"
          placeholder="Ex: Camisetas — grade de cor e tamanho"
          maxlength="120"
          autocomplete="off"
          description="Nome interno, só para achar o grupo aqui no painel."
        />
      </CCol>

      <CCol col="12" md="6">
        <CTextarea
          label="Descrição"
          v-model="form.descricao"
          placeholder="Que categoria este grupo cobre."
          rows="2"
          maxlength="500"
        />
      </CCol>
    </CRow>

    <div class="situacao">
      <CSwitch
        color="success"
        shape="pill"
        :checked="form.ativo === 1"
        @update:checked="definirAtivo"
      />
      <div>
        <strong class="situacao__rotulo">{{ form.ativo ? "Ativo" : "Inativo" }}</strong>
        <small class="d-block text-muted">
          {{
            form.ativo
              ? "Vale para os produtos que casam com as condições."
              : "Fica salvo, mas nenhum canal monta grade com ele."
          }}
        </small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EtapaIdentificacao",
  props: {
    form: { type: Object, required: true },
  },
  methods: {
    definirAtivo(ativo) {
      this.$set(this.form, "ativo", ativo ? 1 : 0);
    },
  },
};
</script>

<style scoped>
.etapa-titulo {
  font-weight: 600;
  color: #1d2939;
  margin-bottom: 20px;
}

.situacao {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
}

.situacao__rotulo {
  font-size: 13px;
  color: #1d2939;
}
</style>
